import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';

export type CommentCreateData = { id: string };

export type CommentCreateResponse = CommentCreateData

export interface CommentCreateBody {
  text: string;
  categoryId: string;
  subCategoryId: string;
  articleId: string;
  fileIds: string[];
}

export const commentCreate = (payload: CommentCreateBody): Action<CommentCreateBody> => ({
  type: actions.commentCreateTrigger.toString(),
  payload,
});

export const commentCreateClear = (): Action => ({
  type: actions.commentCreateClear.toString(),
});

export const commentCreateErrorClear = (): Action => ({
  type: actions.commentCreateErrorReset?.toString(),
});

export function* commentCreateRequestSaga({ payload }: Action<CommentCreateBody>) {
  // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
  ({ payload });
  yield put({
    type: actions.commentCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.commentCreateError.toString(),
      payload: {
        message: 'CommentCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/comments`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CommentCreateData, CommentCreateResponse>(
    response,
    actions.commentCreateSuccess.toString(),
    actions.commentCreateError.toString(),
    false,
    (commentCreateData) => commentCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.commentCreateTrigger.toString(),
    defaultProcessingSaga(
      commentCreateRequestSaga,
      {
        error: actions.commentCreateError.toString(),
        locationCancel: actions.commentCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.commentCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.commentCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.commentCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.commentCreateErrorReset.toString(),
    });
  });
}
